<template>
  <!-- tab 技改项目 -->
  <div style="height: 100%">
    <div class="buttonBox" style="margin-bottom: 10px;">
      <div>
        <div class="chooseButton searchButton" @click="addFactory($t('btn_14'))" v-if="MenuRoleList.indexOf('4')>=0">
          <i class="el-icon-circle-plus-outline"></i>{{ $t('btn_14') }}
        </div>
        <div class="chooseButton searchButton" @click="addFactory($t('btn_15'))">
          <i class="el-icon-edit-outline"></i>{{ $t('btn_15') }}
        </div>
        <div class="chooseButton deleteButton" @click="factoryDel"><i class="el-icon-delete"></i>{{ $t('btn_16') }}
        </div>
      </div>
    </div>


    <div class="tableList">
      <el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableData" highlight-current-row
                @current-change="handleCurrentChangeTree" style="width: 940px;margin: 5px;overflow: auto;
          border-left: 1px solid #ebeef5;border-right: 1px solid #ebeef5;" height="324"
                :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">

        <el-table-column header-align="center" align="center" label="No" type="index" :index="getIndex" width="50">
        </el-table-column>
        <el-table-column prop="project" header-align="center" width="240" label="技改项目" align="left">
          <template slot-scope="scope">
          	<span style="font-size: 16px; font-weight: 600;">
          		{{ scope.row.project1 }}
          	</span>
            <br>
            <span>
            	{{ scope.row.project2 }}
            </span>
            <!-- <popMesBox :popMes="scope.row.content" :hoverMes="scope.row.content" :popWidth="200"></popMesBox> -->
          </template>
        </el-table-column>
        <el-table-column prop="target" label="预期目标" align="center">
        </el-table-column>
        <el-table-column prop="tobear" label="技术担当" align="center">
        </el-table-column>
        <el-table-column prop="sort" label="排序" align="center">
          <template slot-scope="scope">
            <el-button @click="moveUp(scope.row, scope.$index)" :disabled="upDisabled(scope.$index)" type="text"
                       size="small" style="font-size: 20px"><i class="el-icon-arrow-up"></i>
            </el-button>
            <el-button @click="moveDown(scope.row, scope.$index)" :disabled="downDisabled(scope.$index)" type="text"
                       size="small" style="font-size: 20px"><i class="el-icon-arrow-down"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 技改项目里的新增弹框 -->
    <el-dialog v-loading="saveLoading" :title="factoryDialogTitle" :visible.sync="dialogFactory" append-to-body :close-on-click-modal='false'
               width="30%" top="15%" :before-close="handleClose" custom-class="dialogBox">
      <div class="dialogBoxMes" style="padding:0 20px;">
        <div class="dialogMes">
          <p>技改项目</p>
          <div class="mesInput" style="width: 350px;">
            <el-input v-if="factoryDialogTitle == $t('btn_14')" v-model="dialogFactoryEdit.name"></el-input>
            <el-input v-if="factoryDialogTitle == $t('btn_15')" :disabled="true"
                      v-model="dialogFactoryEdit.name"></el-input>
          </div>
        </div>
        <div class="dialogMes" style="margin-top: 15px;">
          <p>技改担当</p>
          <div class="mesInput">
            <el-input v-model="dialogFactoryEdit.code">
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
        </div>
        <div class="dialogMes" style="margin-top: 15px">
          <p>技改方案</p>
          <div class="mesInput" style="width: 350px">
            <el-input type="textarea" v-model="dialogFactoryEdit.remark"></el-input>
          </div>
        </div>
        <div class="dialogMes" style="margin-top: 15px">
          <p>预期目标</p>
          <div class="mesInput" style="width: 350px">
            <el-input type="textarea" v-model="dialogFactoryEdit.remark"></el-input>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          	<span class="buttonBox" style="justify-content: center">
          		<div class="chooseButton searchButton" style="width: 150px" @click="FactoryEditSave(factoryDialogTitle)">{{ $t('btn_13') }}</div>
          	</span>
          </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "@/assets/css/map/map.css"
import "@/assets/css/common/spot.css"
import Page from "@/components/common/page";
import TimePage from "@/assets/js/timePage/timePage.js";
import utils from '@/utils/utils'
import calendar from "@/components/list/calendar/calendar";
import file from "@/assets/js/file/file.js";
import exportMes from "@/components/list/export/export";
import popMesBox from "@/components/list/popover/pop";
import inspectionEquipment from "@/components/list/displayPage/inspectionEquipment";
import inspectionProject from "@/components/list/displayPage/inspectionProject";
import inspectionTime from "@/components/list/displayPage/inspectionTime";


export default {
  name: 'EquipmentInspection',
  components: {
    Page,
    calendar,
    exportMes,
    popMesBox,
    inspectionEquipment,
    inspectionProject,
    inspectionTime,
  },
  data() {
    return {
      saveLoading: false,
      pageNum: 1,
      select: 0,
      pageSize: 8,
      pageCount: 0,
      Readytime: '',
      height: 620,
      MenuRoleList: [],
      dialogFactoryEdit: {
        code: "",
        name: "",
        maker: "",
        model: "",
        saler: "",
        price: "",
        type: this.defaultType,
        unit: this.defaultUnit,
        warningInventory: "",
        warningTime: "",
        remark: "",
      },
      tableData: [{
        project1: '电机清洗 ',
        project2: ' 拆卸电机外壳，利用机油崩喷洗',
        target: '--',
        tobear: '张三',
        sort: '',
      }, {
        project1: '换油保养',
        project2: ' 1打开飞轮后方安全阀 松开飞轮...',
        target: '--',
        tobear: '张三',
        sort: '',
      }, {
        project1: '电机清洗 ',
        project2: ' 拆卸电机外壳，利用机油崩喷洗',
        target: '--',
        tobear: '张三',
        sort: '',
      }, {
        project1: '换油保养',
        project2: ' 1打开飞轮后方安全阀 松开飞轮...',
        target: '--',
        tobear: '张三',
        sort: '',
      }, {
        project1: '换油保养',
        project2: ' 1打开飞轮后方安全阀 松开飞轮...',
        target: '--',
        tobear: '张三',
        sort: '',
      }],
      cardData: [],
      tableDataTreeInfo: {}, //页面数据
      factoryDialogTitle: this.$t('btn_14'), //弹出框的标题
      getTreeMes: '1',
      dialogFactory: false, //弹出框的当前状态
      searchDataList: {
        list: [],
        name: '',
        language: 'zh',
      },
      tableDataTreeTime: [],
      tableDataTreeTimeExport: [], //页面导出的数据
      tableDataTree: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      factoryTypeList: [],
    }
  },
  methods: {
    search() {
      let param = {
        pageNum: 1,
        pageSize: this.pageSize
      }
      this.searchPage(param);
    },
    //分页查询
    searchPage(param) {
      var dataParam = this.searchDataList;
      var newParam = Object.assign(param, dataParam);
      console.log(dataParam)
      this.pageNum = newParam.pageNum;
      this.pageSize = newParam.pageSize;
      // this.getPartsinformation(newParam);
    },

    getIndex(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    exportClick() {
      this.$refs.exportBox.setExportExcel();
    },
    selectProp: function (index) {
      console.log(index)
      this.select = index
    },
    //单选
    handleChange(selection) {
      this.delelist = []
      this.delelist = selection
    },

    upDisabled(index) {
      if (index == 0) {
        return true;
      } else {
        return false;
      }
    },
    downDisabled(index) {
      if (index === this.tableData.length - 1) return true;
      else return false;
    },

    apply() {
    },

    FactoryEditSave() {
      this.saveLoading = true;
      if (this.factoryDialogTitle == this.$t('btn_14')) {
        if (this.dialogFactoryEdit.name == '' || this.dialogFactoryEdit.name == null) {
          utils.messageAlert('请填写技改项目', this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
          return;
        }
        if (this.dialogFactoryEdit.type == '' || this.dialogFactoryEdit.type == null) {
          utils.messageAlert('请填写技改担当', this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
          return;
        }

        file.saveEquipmentFirmInsert(this.dialogFactoryEdit).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.searchDataList.name = this.dialogFactoryEdit.name;
            this.search();
            this.$message({
              message: this.$t('msg_18'),
              type: 'success'
            });
            this.dialogFactory = false;
            this.dialogFactoryEdit = {

              name: "",
              postCode: "",
              remark: "",
              shortName: "",
              type: [],
              updateTime: "",
              website: ""
            }
          } else {
            utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
          }
          this.saveLoading = false;
        }).catch((response) => {
          console.log(response)
          this.saveLoading = false;
          this.$message({
            message: this.$t('msg_77'),
            type: 'error'
          });
        })
      } else {
        file.saveEquipmentFirmUpdate(this.dialogFactoryEdit).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.searchDataList.name = this.dialogFactoryEdit.name;
            this.search();
            this.$message({
              message: '保存成功',
              type: 'success'
            });
            this.dialogFactory = false;
            this.dialogFactoryEdit = {

              name: "",
              postCode: "",
              remark: "",
              shortName: "",
              type: [],
              updateTime: "",
              website: ""
            }
          } else {
            utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
          }
          this.saveLoading = false;
        }).catch((response) => {
          console.log(response)
          this.saveLoading = false;
          this.$message({
            message: this.$t('msg_77'),
            type: 'error'
          });
        })
      }
    },

    //点击编辑选中的数据
    addFactory(title) {
      this.factoryDialogTitle = title;
      if (title != this.$t('btn_14')) {
        if (Object.keys(this.tableDataTreeInfo).length > 0) {
          this.dialogFactory = true;
          this.dialogFactoryEdit = this.tableDataTreeInfo;
          file.saveEquipmentPartsInfoByid(this.tableDataTreeInfo.id).then((response) => {
            const data = response.data;
            if (data.code == "1") {
              this.dialogFactory = true;
              this.dialogFactoryEdit = data.data
            } else {
              utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
            }
          }).catch((response) => {
            console.log(response)
          })
        } else {
          utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
        }
      } else {
        this.dialogFactory = true;
      }
    },
    //弹框关闭
    handleClose() {
      this.dialogFactory = false;
    },


    handleCurrentChangeTree(info) {
      this.tableDataTreeInfo = info;
    },
    // handleCurrentChangeTreeTime(info) {},
    // handleClickSpot(tab, event) {

    // },

    moveUp(item, index) {
      organizationTabJs.sort({
        id: item.id,
        sort: item.sequence,
        id2: this.tableData[index - 1].id,
        sort2: this.tableData[index - 1].sequence
      }).then((response) => {
        const data = response.data;
        if (data.code == 1) {
          this.list();
          this.$emit('reload');
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    moveDown(item, index) {
      organizationTabJs.sort({
        id: item.id,
        sort: item.sequence,
        id2: this.tableData[index + 1].id,
        sort2: this.tableData[index + 1].sequence
      }).then((response) => {
        const data = response.data;
        if (data.code == 1) {
          this.list();
          this.$emit('reload');
        }
      }).catch((response) => {
        console.log(response)
      })
    },


    //点击删除按钮
    factoryDel() {
      let param = this.tableDataTreeInfo.id;
      if (Object.keys(this.tableDataTreeInfo).length > 0) {
        this.$confirm(this.$t('msg_66') + '?', this.$t('label_358'), {
          confirmButtonText: this.$t('label_100'),
          cancelButtonText: this.$t('btn_1'),
          type: 'warning',
        }).then(() => {
          file.delEquipmentParts(param).then((response) => {
            const data = response.data;
            if (data.code == "1") {
              this.search();
              this.$message({
                message: '删除成功',
                type: 'success'
              });
            } else {
              utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
            }
          }).catch((response) => {
            console.log(response)
          })
        }).catch(() => {
        });
      } else {
        utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
      }
    }
  },

  created() {
    this.MenuRoleList = this.$store.getters.getMenu;
    // this.getPartsinformation({
    // 	"pageNum": 1,
    // 	"pageSize": 8,
    // })
    this.search()
  }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/list/displayPage/transformationProject.vue